<template>
	<card :flat="flat" :tile="flat" height="80" :outlined="outlined" :no-spacing="flat || noSpacing" class="py-16 px-16 flex flex-row items-center">
		<div class="flex w-full" :class="{'items-center': !event}">
			<div>
				<skeleton v-if="event" rounded :width="64" :height="64 / (3/2)"/>
				<skeleton v-else rounded width="44" height="44"/>
			</div>
			<div class="flex-grow-x-1 overflow-hidden">
				<div class="pr-4 py-0 flex flex-column justify-center pl-16">
					<skeleton rounded :width="event ? 110 : 90" height="9" class="mb-6"/>
					<skeleton rounded :width="event ? 170 : 120" height="12" class="mb-6"/>
					<skeleton rounded :width="event ? 120 : 80" height="10" class="mb-3"/>
				</div>
			</div>
		</div>
	</card>
</template>

<script>
import CardMixin from "../../Card/CardMixin";

export default {
	name: 'ProfilePreviewSkeleton',

	mixins: [CardMixin],

	props: {

		// Whether the skeleton shall be displayed in the style of an event ProfilePreview
		event: {
			type: Boolean,
			default: false
		}
	}
}
</script>

